module.exports = __webpack_public_path__ + "assets/img/8f23f62a1a863cc1aa565dcd6a1bfe3a.png";